import axios from 'axios'
import { handleUnauthorized } from './utils/authSession'
const serverIp = 'cloud.liveabc.com'
const appPath = '/api'
export const apiPath = `https://${serverIp}${appPath}`
const api = axios.create({
  baseURL: apiPath,
  timeout: 1000 * 60 * 60,
  headers: {
    'Content-Type': 'application/json',
  },
})
api.interceptors.request.use(request => {
  const token = localStorage.getItem('authorizedAIToken')

  if (!request.headers) {
    request.headers = {}
  }

  if (token) {
    request.headers['Authorization'] = `Bearer ${token}`
  }

  axios.defaults.withCredentials = false

  return request
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    handleUnauthorized(error)
    return Promise.reject(error)
  }
)

export default api
